import { Box, ColorOptions, Icon, IconOptions, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { Colors } from '../../util/util'
import { styles } from './styles'
import { CheckboxProps, CheckBoxTypes } from './types'

const getColor = (disabled: boolean, isChecked: boolean, color: any): any => {
  if (disabled) {
    return Colors.DISABLED_GREY
  }
  return isChecked ? color || Colors.PRIMARY : Colors.BLACK_LIGHT
}

const getId = (type: CheckBoxTypes, isChecked: boolean): IconOptions => {
  if (type === CheckBoxTypes.CHECK_LIST) {
    return 'SUCCESSFUL_FILLED'
  } else if (type === CheckBoxTypes.ROUNDED && isChecked) {
    return 'SUCCESSFUL_FILLED'
  } else if (type === CheckBoxTypes.ROUNDED && !isChecked) {
    return 'RADIOBUTTON_OFF'
  }
  if (isChecked) {
    return 'CHECKBOX_CHECKED'
  }
  return 'CHECKBOX_UNCHECKED'
}

const getTxtColor = (disabled: boolean): string => {
  if (disabled) {
    return Colors.HELPER_TEXT
  }
  return Colors.OTP_GREY
}

const Checkbox: FC<CheckboxProps> = ({
  type = CheckBoxTypes.DEFAULT,
  isChecked,
  onPress,
  disabled = false,
  size,
  color,
  fieldName,
  setFieldValue,
  title,
  textColor,
  showCompleteText = false,
}: CheckboxProps) => {
  const state = disabled ? 'disabledStyle' : 'checkboxStyles'

  const handleChange = (): void => {
    if (!disabled) {
      if (onPress) {
        onPress()
      }
      if (fieldName && setFieldValue) {
        setFieldValue(fieldName, isChecked)
      }
    }
  }

  const isEmpty = () => {
    return !title || title.length === 0
  }

  return (
    <Box
      accessibilityLabel="checkbox"
      testID="checkbox"
      onPress={handleChange}
      disabled={disabled}
      {...styles[type][state]}
      underlayColor={'TRANSPARENT'}>
      <Box {...styles[type].container} testID={isChecked ? 'checked' : 'unchecked'}>
        <Icon size={size || 16} color={getColor(disabled, isChecked, color)} id={getId(type, isChecked)} />
        <Spacer direction="horizontal" size={8} hide={isEmpty()} />
        <Text
          numberOfLines={showCompleteText ? undefined : 1}
          type="caption"
          color={(textColor as ColorOptions) || (getTxtColor(disabled) as ColorOptions)}>
          {title}
        </Text>
      </Box>
    </Box>
  )
}
export { Checkbox, CheckBoxTypes }
